export const QUERY_WORK_LOG_CONFIG = "QUERY_WORK_LOG_CONFIG";
export const QUERY_WORK_LOG_CONFIG_FOR_PAYEE =
  "QUERY_WORK_LOG_CONFIG_FOR_PAYEE";
